import type { DefaultPanelTab } from "./panelConfig";

export type WidgetOpenSource =
  | "icon"
  | "banner"
  | "url"
  | "welcome_offer_applied";

export interface WidgetEvent {
  type: "open";
  tab?: DefaultPanelTab;
  source?: WidgetOpenSource;
}

type Listener = (event: WidgetEvent) => void;

const listeners = new Set<Listener>();

export const widgetEventBus = {
  subscribe(cb: Listener): () => void {
    listeners.add(cb);
    return () => listeners.delete(cb);
  },
  emit(event: WidgetEvent): void {
    listeners.forEach((cb) => cb(event));
  },
};
